export default "__VITE_ASSET__Dgooeyls__"